import { render, staticRenderFns } from "./DashboardWidgetSalesWindow.vue?vue&type=template&id=59998038&scoped=true"
import script from "./DashboardWidgetSalesWindow.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetSalesWindow.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetSalesWindow.vue?vue&type=style&index=0&id=59998038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59998038",
  null
  
)

export default component.exports